import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './Common';

// handle the public routes
function PublicRoute({ component: Component, ...rest }) {
    let token = true
    var path = ''
    // if (token) {
    // path = '/quickLinks'
    // }
    // else {
    path = '/dashboard'
    // }
    return (
        <Route
            {...rest}
            render={(props) => !getToken() ? <Component {...props} /> : <Redirect to={{ pathname: path }} />}
        />
    )
}

export default PublicRoute;